(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_footer-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    if (window.innerWidth > 769) return;

    const toggle = e.target.closest('.footer__menu--accordion .footer__heading-toggle');
    if (!toggle) return;

    const menu = toggle.closest('.footer__menu');
    const list = menu.querySelector('.footer-block__details-content');
    const isOpen = list.classList.contains('is-open');
    
    document.querySelectorAll('.footer__menu--accordion').forEach((item) => {
      const otherList = item.querySelector('.footer-block__details-content');
      const otherToggle = item.querySelector('.footer__heading-toggle');

      if (item !== menu) {
        otherList.style.height = '0px';
        otherList.classList.remove('is-open');
        otherToggle.classList.remove('is-open');
      }
    });

    if (isOpen) {
      list.style.height = list.scrollHeight + 'px';
      requestAnimationFrame(() => {
        list.style.height = '0px';
      });
      list.classList.remove('is-open');
    } else {
      list.style.height = list.scrollHeight + 'px';
      list.classList.add('is-open');
    }

    toggle.classList.toggle('is-open');
  });
  } catch(e) { console.error(e); }
})();

})();
